import authComponents from '@js/components/auth'
import courseComponents from '@js/components/course'
import searchComponents from '@js/components/search'
import globalComponents from '@js/components/global'
import accountComponents from '@js/components/account'
import checkoutComponents from '@js/components/checkout'
import navigationComponents from '@js/components/navigation'
import pageBuilderComponents from '@js/components/pageBuilder'

const components = [
  ...authComponents,
  ...courseComponents,
  ...searchComponents,
  ...accountComponents,
  ...globalComponents,
  ...checkoutComponents,
  ...navigationComponents,
  ...pageBuilderComponents,
]

export default components
